module.exports = __webpack_public_path__ + "img/instagram.baee7888.svg";